/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { AppConfig } from '@/types/config';

export type PasswordlessCodeDeliveryChannel = 'email' | 'sms';

/**
 * Login-sheet OTP channels configured for passwordless sign-in.
 * When only one channel is returned, the send-code step is skipped and the code is sent immediately.
 */
export function getPasswordlessCodeDeliveryChannels(config: AppConfig): PasswordlessCodeDeliveryChannel[] {
    const mode = config.features.passwordlessLogin.mode;
    if (mode === 'sms') return ['sms'];
    if (mode === 'email') return ['email'];

    return ['email'];
}

export function shouldShowPasswordlessCodeDeliveryStep(channels: PasswordlessCodeDeliveryChannel[]): boolean {
    return channels.length > 1;
}
